module.exports = __webpack_public_path__ + "img/Redshift-Model.32f5acdc.png";